/**
 * Copyright 2023 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */

import { Button, View } from '@az/starc-ui'
import { FC, PropsWithChildren } from 'react'

interface Props extends PropsWithChildren {
  type?: 'submit' | 'cancel' | 'button'
  disabled?: boolean
  variant?: 'primary' | 'secondary' | 'super' | 'tertiary' | 'ghost'
  formId?: string
}

interface SubmitProps {
  type?: 'submit'
  onClick?: never
}

interface ReturnProps {
  type?: 'cancel'
  onClick: () => void
}
interface ButtonProps {
  type?: 'button'
  onClick: () => void
}

export const InputSubmit = ({
  children,
  type = 'submit',
  variant,
  onClick,
  disabled,
  formId,
}: Props & (SubmitProps | ReturnProps | ButtonProps)) => {
  return (
    <View>
      <Button
        attributes={{
          form: formId,
        }}
        size="large"
        onClick={onClick}
        type={type === 'submit' ? type : 'button'}
        variant={variant || (type == 'cancel' ? 'secondary' : 'primary')}
        disabled={disabled}
      >
        {children ? children : type == 'cancel' ? 'Cancel' : 'Submit'}
      </Button>
    </View>
  )
}

const SubmitArea: FC<PropsWithChildren> = ({ children }) => {
  return (
    <View direction="row" justify="end" gap={4}>
      {children}
    </View>
  )
}

InputSubmit.Area = SubmitArea
